import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';
import TSGesuchsPersonDaten from './TSGesuchsPersonDaten';

export default class TSGesuchsPerson extends TSAbstractEntity implements TSSerializable<TSGesuchsPerson> {

    private _gesuchsPersonDatenFS: TSGesuchsPersonDaten;

    private _gesuchsPersonDatenGS: TSGesuchsPersonDaten;

    public get gesuchsPersonDatenFS(): TSGesuchsPersonDaten {
        return this._gesuchsPersonDatenFS;
    }

    public set gesuchsPersonDatenFS(value: TSGesuchsPersonDaten) {
        this._gesuchsPersonDatenFS = value;
    }

    public get gesuchsPersonDatenGS(): TSGesuchsPersonDaten {
        return this._gesuchsPersonDatenGS;
    }

    public set gesuchsPersonDatenGS(value: TSGesuchsPersonDaten) {
        this._gesuchsPersonDatenGS = value;
    }

    deserialize(restObject: any): TSGesuchsPerson {
        super.deserialize(restObject);
        if (restObject.gesuchsPersonDatenFS) {
            this.gesuchsPersonDatenFS = new TSGesuchsPersonDaten().deserialize(restObject.gesuchsPersonDatenFS);
        }
        if (restObject.gesuchsPersonDatenGS) {
            this.gesuchsPersonDatenGS = new TSGesuchsPersonDaten().deserialize(restObject.gesuchsPersonDatenGS);
        }

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.gesuchsPersonDatenFS = this.serializeOrInit(this.gesuchsPersonDatenFS, restObject.gesuchsPersonDatenFS);
        restObject.gesuchsPersonDatenGS = this.serializeOrInit(this.gesuchsPersonDatenGS, restObject.gesuchsPersonDatenGS);

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSGesuchsPerson.ts